function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResultFoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.001 .996)",
    "data-name": "Group 8348"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45461",
    d: "M379.659 181.824H349.48a2.6 2.6 0 0 0-2.594 2.594v67.074l-.345.105-7.4 2.267a1.385 1.385 0 0 1-1.728-.918l-22.022-71.934a1.383 1.383 0 0 1 .918-1.727l11.409-3.494 33.074-10.124 11.409-3.493a1.382 1.382 0 0 1 1.728.916l5.629 18.387z",
    transform: "translate(-308.556 -157.234)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45462",
    d: "M353.871 158.157 347.087 136a2.939 2.939 0 0 0-3.671-1.95l-16.04 4.91-33.076 10.122-16.04 4.911a2.943 2.943 0 0 0-1.95 3.672L299.5 233.4a2.945 2.945 0 0 0 2.812 2.081 2.912 2.912 0 0 0 .86-.13l10.995-3.365.346-.107v-.361l-.346.105-11.1 3.4a2.6 2.6 0 0 1-3.24-1.721l-23.185-75.736a2.592 2.592 0 0 1 1.72-3.239l16.04-4.911 33.072-10.124 16.04-4.911a2.59 2.59 0 0 1 3.239 1.72l6.753 22.06.107.346h.36z",
    transform: "translate(-276.182 -133.913)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45463",
    d: "M380.76 167.5a1.56 1.56 0 0 1-1.489-1.1l-2.227-7.276a1.556 1.556 0 0 1 1.032-1.944l30.427-9.315a1.558 1.558 0 0 1 1.944 1.033l2.227 7.276a1.559 1.559 0 0 1-1.032 1.944l-30.427 9.315a1.566 1.566 0 0 1-.455.067z",
    transform: "translate(-359.543 -145.393)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 788",
    cx: 3.459,
    cy: 3.459,
    r: 3.459,
    transform: "translate(29.427 .86)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 789",
    cx: 2.19,
    cy: 2.19,
    r: 2.19,
    transform: "translate(30.696 2.128)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45464",
    d: "M592.242 367.066h-58.453a1.471 1.471 0 0 1-1.47-1.47v-70.04a1.471 1.471 0 0 1 1.47-1.47h58.453a1.471 1.471 0 0 1 1.47 1.47V365.6a1.471 1.471 0 0 1-1.47 1.466z",
    transform: "translate(-488.022 -266.384)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45465",
    d: "M535.161 274.087h-36.4a2.944 2.944 0 0 0-2.94 2.94v70.523l.346-.105v-70.418a2.6 2.6 0 0 1 2.594-2.594h36.511zm31.734 0h-68.137a2.944 2.944 0 0 0-2.94 2.94v79.205a2.944 2.944 0 0 0 2.94 2.94H566.9a2.943 2.943 0 0 0 2.939-2.94v-79.205a2.943 2.943 0 0 0-2.939-2.94zm2.594 82.145a2.6 2.6 0 0 1-2.594 2.594h-68.137a2.6 2.6 0 0 1-2.594-2.594v-79.205a2.6 2.6 0 0 1 2.594-2.594H566.9a2.6 2.6 0 0 1 2.594 2.594z",
    transform: "translate(-457.833 -249.843)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45466",
    d: "M642.2 266.809h-31.82a1.558 1.558 0 0 1-1.557-1.557v-7.609a1.558 1.558 0 0 1 1.557-1.557h31.82a1.558 1.558 0 0 1 1.556 1.557v7.609a1.558 1.558 0 0 1-1.557 1.557z",
    transform: "translate(-551.292 -234.956)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 790",
    cx: 3.459,
    cy: 3.459,
    r: 3.459,
    transform: "translate(71.534 14.733)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 791",
    cx: 2.107,
    cy: 2.107,
    r: 2.107,
    transform: "translate(72.886 16.085)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultFoundIcon);
export default __webpack_public_path__ + "static/media/NoResultFoundIcon.de080ff076d074a9cc44204930b0aa42.svg";
export { ForwardRef as ReactComponent };